/* eslint-disabled */

export default class TranslationExtend {


  constructor (object?: any) {
  }

  postConstruct () {
  }
}
